__turbopack_context__.v({
  "banner": "c3Dc-G_banner",
});
